module.exports = __webpack_public_path__ + "static/media/(DH)-Prata-02.d8540dbf.jpg";